import { ICaseTaskFilters, ITask } from "../../features/tasks/state/tasksTypes"

export const isTaskFiltered = (task: ITask, filters: ICaseTaskFilters): boolean => {
  if (!filters) return false
  if(filters.showOutstanding && filters.showCompleted) return false
  if(filters.showCompleted && !task.isComplete) return true
  if(filters.showOutstanding && task.isComplete) return true
}
